import clsx from 'clsx';

import { classNamesFor } from '../../../utils/classNames';
import { RowInset, RowInsetProps } from '../../containers/RowInset';

const classNamesFactory = classNamesFor('DialogFooter');

const classNames = {
  root: classNamesFactory.root(),
};

export type DialogFooterProps = {
  /**
   * Show divider at the top of the footer
   */
  divider?: boolean;
} & RowInsetProps;

/**
 * Dialog footer component with optional start content, end content, and divider
 */
export const DialogFooter = ({
  divider,
  className,
  testId = 'dialog-footer',
  ...rest
}: DialogFooterProps) => {
  return (
    <RowInset
      py={20}
      dividerTop={divider}
      className={clsx(classNames.root, className)}
      testId={testId}
      alignItems="center"
      {...rest}
    />
  );
};

DialogFooter.classNames = classNames;
